import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        inmate: {
            name: "default"
        },
        modalData: {
            headerText: "",
            bodyText:
                "",
            acceptButtonText: "OK",
            closeButtonText: "Cancel",
            closeButtonExists: true,
            acceptButtonExists: false,
            entryFieldExists: false,
        },
        currentInmates: [],
        //Flip this to false for clients who do not want historic data to be public
        AllowHistoricData: true,
        historicSearch: {},
        historicResults: [],
    },
    getters: {},
    mutations: {},
    actions: {},
});